export default __webpack_public_path__ + "static/media/ic_timer.8659ce4d.svg";